module.exports = __webpack_public_path__ + "static/media/p4.8bdba4a5.jpg";